import translations from '@/locales';

class TranslationService {
    async loadTranslations() {
        return translations;
    }
}
export default new TranslationService()